import { useValidationsField } from '@insurance/hooks'
import { InputParsedNumber } from '@shared/components'
import { DEFAULT_CURRENCY } from '@shared/constants'
import { Col, Form, Input, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { useAccidentInsuranceValues } from './AccidentInsuranceContext'
import { formProps } from './utils'

export const InsuranceAmount = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { insuredAmountProps } = formProps(t)
  const { isEditable } = useAccidentInsuranceValues()

  return (
    <Row gutter={[12, 12]}>
      <Col xs={{ span: 24 }} md={{ span: 12 }}>
        <Form.Item {...insuredAmountProps} rules={[required]}>
          <InputParsedNumber
            disabled={isEditable}
            step={1000}
            min={1000}
            placeholder={insuredAmountProps.label}
          />
        </Form.Item>
      </Col>

      <Col xs={{ span: 24 }} md={{ span: 12 }}>
        <Form.Item label={t('currency')}>
          <Input
            disabled
            placeholder={t('currency')}
            value={DEFAULT_CURRENCY}
          />
        </Form.Item>
      </Col>
    </Row>
  )
}
